import React from 'react'

import AWSImg from '../assets/aws.png'
import ReactImg from '../assets/react.png'
import PythonImg from '../assets/python.png'
import CSS from '../assets/css.png'
import Tailwind from '../assets/tailwind.png'
import NodeImg from '../assets/node.png'
import HTML from '../assets/html.png'
import SeabornImg from '../assets/seaborn.png'
import CplusplusImg from '../assets/cplusplus.png'
import JavascriptImg from '../assets/javascript.png'
import SQLImg from '../assets/sql.png'
import LangchainImg from '../assets/langchain.png'
import PyTorchImg from '../assets/pytorch.png'
import DockerImg from '../assets/docker.png'
import KafkaImg from '../assets/apachekafka.png'
import APIImg from '../assets/api.png'

const Skills = () => {
  return (
    <div name='skills' className='w-full h-screen bg-[#617ea3] text-[#000000]'>
        {/* container */}
        <div className='max-w-[1000px] mx-auto p-4 pt-96 sm:pt-4 sm:flex flex-col justify-center w-full h-full'>
            <div>
                <p className='text-4xl font-bold inline border-b-4 text-[#1c337b] border-[#14213d]'>Skills</p>
                <p className='py-4 text-[#000000] font-bold'>These are some of the technologies and frameworks that I am comfortable working with.</p>
            </div>
            {/* container all icons */}
            <div className='w-full grid grid-cols-2 sm:grid-cols-4 gap-4 text-center py-8'>
                <div className='bg-[#567aa9] p-8 shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                    <img className='w-24 mx-auto' src={PythonImg} alt='Python Icon'/>
                    <p className='mt-2 font-bold'>Python</p>
                </div>

                <div className='bg-[#567aa9] p-8 shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                    <img className='w-24 mx-auto' src={CplusplusImg} alt='C++ Icon'/>
                    <p className='mt-2 font-bold'>C++</p>
                </div>

                <div className='bg-[#567aa9] p-8 shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                    <img className='w-24 mx-auto' src={JavascriptImg} alt='Javascript Icon'/>
                    <p className='mt-2 font-bold'>Javascript</p>
                </div>

                <div className='bg-[#567aa9] p-8 shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                    <img className='w-24 mx-auto' src={SQLImg} alt='SQL Icon'/>
                    <p className='mt-2 font-bold'>SQL</p>
                </div>

                <div className='bg-[#567aa9] p-8 shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                    <img className='w-24 mx-auto' src={LangchainImg} alt='Langchain Icon'/>
                    <p className='mt-2 font-bold'>Langchan</p>
                </div>

                <div className='bg-[#567aa9] p-8 shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                    <img className='w-24 mx-auto' src={PyTorchImg} alt='PyTorch Icon'/>
                    <p className='mt-2 font-bold'>PyTorch</p>
                </div>

                <div className='bg-[#567aa9] p-8 shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                    <img className='w-24 mx-auto' src={DockerImg} alt='Docker Icon'/>
                    <p className='mt-2 font-bold'>Docker</p>
                </div>

                <div className='bg-[#567aa9] p-8 shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                    <img className='w-24 mx-auto' src={KafkaImg} alt='Apache Kafka Icon'/>
                    <p className='mt-2 font-bold'>Apache Kafka</p>
                </div>
                
                <div className='bg-[#567aa9] p-8 shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                    <img className='w-24 mx-auto' src={SeabornImg} alt='Seaborn Icon'/>
                    <p className='mt-2 font-bold'>Seaborn</p>
                </div>

                <div className='bg-[#567aa9] p-8 shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                    <img className='w-24 mx-auto' src={AWSImg} alt='AWS Icon'/>
                    <p className='mt-2 font-bold'>AWS Services</p>
                </div>

                <div className='bg-[#567aa9] p-8 shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                    <img className='w-24 mx-auto' src={NodeImg} alt='NodeJS Icon'/>
                    <p className='mt-2 font-bold'>NodeJS</p>
                </div>

                <div className='bg-[#567aa9] p-8 shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                    <img className='w-24 mx-auto' src={APIImg} alt='API Icon'/>
                    <p className='mt-2 font-bold'>API Integration</p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Skills